import { recentlyViewedProductsKey } from '@constants';
import { logger } from '@utils/logger';

// constants
const MAX_VIEWED_PRODUCTS = 12;
const EXPIRE_PRODUCT_TIME = 1000 * 60 * 60 * 24 * 2; // 2 days

// types
export type ProductInfo = {
  id: number;
  saveToStorageAt: number;
};

// Returns viewed products ids or `null` if impossible retrieve ids
// (for example because of invalid JSON structure or disabled storage)
export const getViewedProductsIds = () => {
  try {
    const storageData = localStorage.getItem(recentlyViewedProductsKey);
    if (storageData) {
      const productsInfo = JSON.parse(storageData) as ProductInfo[];

      // Filter expired products
      const freshProducts = productsInfo.filter(
        (productInfo) => (
          Date.now() - productInfo.saveToStorageAt < EXPIRE_PRODUCT_TIME
        ),
      );

      // If there is expired product, save only fresh products
      if (freshProducts.length < productsInfo.length) {
        localStorage.setItem(
          recentlyViewedProductsKey,
          JSON.stringify(freshProducts),
        );
      }

      return freshProducts;
    }
    return [];
  } catch (e) {
    logger.warn(e);
  }

  return null;
};

// Add new viewed product id to storage
export const addViewedProductId = (productId: number) => {
  const productsIds = getViewedProductsIds();
  if (productsIds !== null) {
    const alreadySaved = productsIds.findIndex(
      (productInfo) => productInfo.id === productId,
    ) !== -1;

    if (!alreadySaved) {
      productsIds.push({
        id: productId,
        saveToStorageAt: Date.now(),
      });

      try {
        localStorage.setItem(
          recentlyViewedProductsKey,
          JSON.stringify(productsIds.slice(-MAX_VIEWED_PRODUCTS)),
        );
      } catch (e) {
        logger.warn(e);
      }
    }
  }
};
